export default "__VITE_ASSET__C0Hixz2B__"